import { Button } from '@mantine/core';
import { IconArrowsLeftRight, IconCash, IconPlus, IconReceipt } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useCanCreate, useHasPermission } from 'src/Hooks/Shared/useHasPermission';
import { useIsAssetAboveQuotas } from 'src/Hooks/Shared/useIsAssetAboveQuotas';
import useNavigateKeepingSearch from 'src/Hooks/Shared/useNavigateKeepingSearch';
import useOperationActions from 'src/Hooks/Shared/useOperationActions';

import styles from './OperationsToolbar.module.scss';

const OperationsToolbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigateKeepingSearch();
  const { hasPermission: canCreate } = useCanCreate('expense');
  const { hasPermission: isFinanceAdmin } = useHasPermission('financeAdmin', 'full');
  const assetAboveQuotas = useIsAssetAboveQuotas();

  const {
    addExpense: handleAddExpense,
    addIncome: handleAddIncome,
    addTransfer: handleAddTransfer,
  } = useOperationActions('operations');

  if (!canCreate && !isFinanceAdmin) return null;

  return (
    <div className={styles.container}>
      {canCreate && (
        <div className={styles.actions}>
          <Button
            leftSection={<IconReceipt size={18} />}
            onClick={handleAddExpense}
            disabled={assetAboveQuotas}
          >
            {t('expenses.actions.addExpense', 'Ajouter une dépense')}
          </Button>
          <Button
            variant="outline"
            leftSection={<IconCash size={18} />}
            onClick={handleAddIncome}
            disabled={assetAboveQuotas}
          >
            {t('expenses.actions.addIncome', 'Ajouter une recette')}
          </Button>
          <Button
            variant="outline"
            leftSection={<IconArrowsLeftRight size={18} />}
            onClick={handleAddTransfer}
            disabled={assetAboveQuotas}
          >
            {t('expenses.actions.addTransfer', 'Enregistrer un remboursement')}
          </Button>
          {isFinanceAdmin && (
            <Button
              variant="outline"
              leftSection={<IconPlus size={18} />}
              onClick={() => navigate('fund-calls/new')}
            >
              {t('expenses.actions.fundCall', 'Lancer un appel de fonds')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default OperationsToolbar;
